import React from "react";
import "./Timeline.scss";

const PinOutline = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon-pin-outline"
    aria-hidden
  >
    <path
      d="M12 2C8.68629 2 6 4.68629 6 8c0 4.4183 6 12 6 12s6-7.5817 6-12c0-3.3137-2.6863-6-6-6z"
      stroke="white"
      strokeWidth="1.6"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="8" r="2.2" fill="white" />
  </svg>
);

const Drop = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon-pin-outline"
    aria-hidden
  >
    <g transform="scale(1 -1) translate(0 -24)">
      <path
        d="M12 2C8.68629 2 6 4.68629 6 8c0 4.4183 6 12 6 12s6-7.5817 6-12c0-3.3137-2.6863-6-6-6z"
        stroke="white"
        strokeWidth="1.6"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="8" r="2.2" fill="white" />
    </g>
  </svg>
);

const Timeline = ({
  leftPct = "4%",
  yellowLeft = "70%",
  yellowWidth = "11%",
}) => {
  return (
    <div className="ah-timeline">
      <div className="ah-line" />

      <div className="ah-dot ah-dot-left" />
      <div
        className="ah-yellow"
        style={{ left: yellowLeft, width: yellowWidth }}
        aria-hidden
      >
        {Array.from({ length: 22 }).map((_, i) => (
          <span key={i} className="seg" />
        ))}
      </div>

      <div
        className="ah-pin"
        style={{
          left: `calc(${yellowLeft} + ${yellowWidth})`,
        }}
      >
        <PinOutline />
      </div>

      <div
        className="ah-drop"
        style={{
          left: `calc(${yellowLeft} + (${yellowWidth} * 0.01))`,
        }}
      >
        <Drop />
      </div>
    </div>
  );
};
export default Timeline;
